<template>

    <div
        :class="['a-radio-btn', error?'error':'', store.state, $attrs.class, {'a-radio-btn--active': $attrs.modelValue === option.value}]"
        role="radio"
        :aria-label="label"
    >

        <label :for="option.key" class="a-radio-btn-wrap">
            <span class="a-radio-btn-area">
                <input
                    type="radio"
                    :name="option.name"
                    :value="option.value"
                    :id="option.value"
                    :checked="$attrs.modelValue === option.value"
                    @change="onChange"
                >
                <span class="a-radio-btn-control"></span>
                <span class="a-radio-btn-label">{{ option.label }}</span>
            </span>
        </label>

    </div>
</template>

<script>
import {reactive} from "vue";

export default {
    name: "ARadioBtn",
    props: {
        option: {
            required: true,
            type: Object,
            validator(val) {
                return Object.keys(val).includes('value') && Object.keys(val).includes('label') && Object.keys(val).includes('name')
            }
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        state: {
            type: Object,
            default: () => ({
                error: false,
                errorMsg: null
            })
        },
    },
    inheritAttrs: false,
    setup: (props, ctx) => {

        if (props.option.checked) {
            ctx.emit('update:modelValue', props.option.value)
        }

        let store = reactive({
            state: {
                // selected: isSelected(),
                ...props.state
            }
        })

        const onChange = (e) => {
            console.log(e.target.value)
            ctx.emit('update:modelValue', e.target.value)
        }


        return {
            store,
            onChange
        }
    }
}
</script>

<style scoped lang="scss">
$activeColor: var(--c-secondary-200);
$defaultColor: var(--c-gray-600);
$size: rem(16);

.a-radio-btn {
    position: relative;
    font-weight: 400;
    font-size: rem(14);
    line-height: rem(20);
    margin-bottom: rem(26);

    &-control {
        display: inline-block;
        width: $size;
        height: $size;
        border: 4px solid $defaultColor;
        background-color: $defaultColor;
        border-radius: $size;

        .a-radio-btn--active & {
            border: 4px solid $activeColor;
            background-color: #fff;
        }
    }

    &-label {
        margin-left: rem(9);
    }

    &-area {
        display: flex;
        align-items: center;
    }

    input {
        position: absolute;
        top: 0;
        left: 0;
        visibility: hidden;
        z-index: -1;
        width: 1px;
        height: 1px;
    }

    label {
        cursor: pointer;
    }
}
</style>